import { fetch } from '@/shared/fetch';
import { ISelfResponse } from '@/shared/interfaces';

export const fetchProfile = async () => {
    return await fetch<ISelfResponse>('/api/patients/self/v2', 'GET');
};
